<template>
  <v-popover>
    <v-btn icon small>
      <v-icon :size="iconSize" color="primary">
        perm_media
      </v-icon>
    </v-btn>
    <template slot="popover">
      <v-card>
        <v-img
          v-if="MediaData.type === 'image'"
          :style="{
            height: tooltipSize.height + 'px',
            width: tooltipSize.width + 'px',
          }"
          :src="MediaData.url"
        />
        <iframe
          v-if="MediaData.type === 'video'"
          :src="MediaData.url"
          frameborder="0"
        />
        <v-card-actions>
          <v-spacer />
          <v-btn v-close-popover icon small>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-popover>
</template>

<script>
import { VClosePopover, VPopover } from "v-tooltip"

export default {
  props: {
    MediaData: {
      type: Object,
      required: true,
    },
    tooltipSize: {
      type: Object,
      default: function() {
        return {
          width: 420,
          height: 320,
        }
      },
    },
    iconSize: {
      type: Number,
      default: 16,
    },
  },
  directives: {
    "close-popover": VClosePopover,
  },
  components: {
    "v-popover": VPopover,
  },
}
</script>

<style scoped></style>
